import { FETCH_CREDENTIALS } from '../actions/types';

const initialState = null;

function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CREDENTIALS:
      return action.payload || [];
    default:
      return state;
  }
}
export default reducer;
